import { useEffect, useState } from "react";
import { BRAND } from "@/lib/constants";

const STORAGE_KEY = "mdsw_age_verified_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    try {
      const ok = localStorage.getItem(STORAGE_KEY);
      if (ok !== "yes") setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const handleYes = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "yes");
    } catch {}
    setOpen(false);
  };

  const handleNo = () => {
    setDenied(true);
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      data-testid="age-gate-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
    >
      <div className="absolute inset-0 bg-black/85 backdrop-blur-2xl" />
      <div className="relative w-full max-w-lg rounded-2xl border border-white/10 bg-[#13161C]/90 p-8 md:p-10 shadow-[0_0_80px_-20px_rgba(40,192,216,0.35)] animate-fade-up">
        <div className="flex items-center gap-3 mb-6">
          <img
            src={BRAND.logoTransparent}
            alt="MD Supply Wellness"
            className="h-10 w-auto object-contain"
          />
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#28C0D8] font-semibold">
              MD Supply Wellness
            </p>
            <p className="text-xs text-[#94A3B8]">Bethesda, Maryland</p>
          </div>
        </div>

        <h2
          id="age-gate-title"
          className="font-display text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight"
        >
          Are you 21 or older?
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-[#94A3B8]">
          You must be 21 years of age or a registered Maryland medical patient
          to enter this site. By clicking "Yes", you confirm you meet
          Maryland&apos;s legal requirements.
        </p>

        {denied ? (
          <div
            className="mt-6 rounded-lg border border-[#28C0D8]/30 bg-[#28C0D8]/5 p-4 text-sm text-[#F8FAFC]"
            data-testid="age-gate-denied-message"
          >
            We&apos;re sorry — you must be 21+ to access this site. Please come
            back when you meet the legal age requirement.
          </div>
        ) : (
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={handleYes}
              data-testid="age-gate-yes"
              className="btn-teal-glow inline-flex items-center justify-center rounded-full bg-[#28C0D8] px-5 py-2.5 text-sm md:px-6 md:py-3 md:text-[15px] font-semibold text-[#0A0B0E] hover:bg-[#1FA8BC]"
            >
              Yes, I am 21+
            </button>
            <button
              type="button"
              onClick={handleNo}
              data-testid="age-gate-no"
              className="inline-flex items-center justify-center rounded-full border border-white/15 bg-transparent px-5 py-2.5 text-sm md:px-6 md:py-3 md:text-[15px] font-medium text-white/80 hover:text-white hover:border-white/30 transition"
            >
              No, I am under 21
            </button>
          </div>
        )}

        <p className="mt-6 text-[11px] uppercase tracking-[0.18em] text-[#64748B]">
          For use only by adults 21+ or MD registered medical patients.
        </p>
      </div>
    </div>
  );
}
